import { Box, Button } from '@mui/material';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import { AttachmentStatus } from '../../../models/models';
import { rejectAttachmentStart } from '../../../store/attachment/attachment.action';
import { closeDialog } from '../../../store/dialog/dialog.action';
import { setIsError } from '../../../store/error/error.action';
import { getNodeStart } from '../../../store/node/node.action';
import { selectNodeSelected } from '../../../store/node/node.selector';
import { FlexBoxFullWHColumn } from '../../layout/layout.styles';
import DialogContent from '../../ui/dialog-content/dialog-content.component';
import DialogTitle from '../../ui/dialog-title/dialog-title.component';
import { TextArea, TextAreaLabel } from './dialog-reject-attachment.styles';

const DialogRejectAttachment = ({ inputData }: { inputData: any }) => {
    const notesInput = useRef<HTMLInputElement>(null);

    const nodeSelected = useSelector(selectNodeSelected);

    const dispatch = useDispatch();

    const type: 'document' | 'model3d' = inputData.type;
    const status: AttachmentStatus = inputData.status;
    const title1 =
        type === 'document' ? 'Rifiuta documento' : 'Rifiuta modello 3D';
    const title2 =
        status === 'active'
            ? `caricato da ${inputData.created_by}`
            : status === 'replaced'
            ? `sostituito da ${inputData.replaced_by}`
            : `approvato da ${inputData.approved_by}`;
    const title = `${title1} ${title2}`;

    const handleReject = () => {
        if (!notesInput.current?.value) {
            dispatch(setIsError(true, 'Motivazione obbligatoria'));
            return;
        }

        const refusalNotes = notesInput.current!.value;
        dispatch(
            rejectAttachmentStart(
                inputData.id,
                inputData.type,
                refusalNotes,
                () => {
                    dispatch(closeDialog());
                    dispatch(getNodeStart(nodeSelected!.id));
                }
            )
        );
    };

    return (
        <Fragment>
            <DialogTitle title={title} />
            <DialogContent>
                <FlexBoxFullWHColumn>
                    <TextAreaLabel>MOTIVAZIONE</TextAreaLabel>
                    <TextArea fullWidth multiline inputRef={notesInput} />
                    <Box my={1} />
                    <Button
                        variant="contained"
                        sx={{
                            borderRadius: '15px',
                            color: 'info.main',
                            fontWeight: 'bold',
                            width: '206px !important',
                            alignSelf: 'end',
                            lineHeight: '1.5',
                        }}
                        onClick={handleReject}
                    >
                        Conferma rifiuto
                    </Button>
                </FlexBoxFullWHColumn>
            </DialogContent>
        </Fragment>
    );
};

export default DialogRejectAttachment;
